<template>
  <div style="font-family: -apple-system-font,PingFang SC,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
    <div class="carousel">
      案例精选
    </div>
    <div class="case_main">
      <div class="case_top">
        <div class="case_title">西安维尔利环保科技有限公司环卫信息管理系统</div>
        <div class="case_time">
          <img
            src="../../assets/images/developerCommunity/dev_time.png"
            alt=""
          />
          <span>2020/06/12</span>
        </div>
        <hr />
      </div>
      <div class="case_detail">
        <!-- <div class="model"> -->
        <!-- <div class="model_title">【企业介绍】</div> -->
        <!-- <div class="section"></div> -->
        <!-- </div> -->
        <div class="model">
          <div class="model_title">【项目概况】</div>
          <div>
            <div class="section">
              西安维尔利环卫信息管理系统于2019年1月正式运行，项目部署于陕西西安，业主单位为西安维尔利环保科技有限公司。系统实现对餐厨垃圾的来源、去向、产生量、清运量、处理量实时在线监管，实现从源头产出、清运过程、垃圾处理“三量合一”监管，避免餐厨垃圾清运过程中出现遗洒、私运、偷倒的情况发生，该项目餐厨垃圾收运负荷：400 吨/天；油脂收运负荷：40 吨/天。
            </div>
            <div class="section">
              <img src="../../assets/caseDetail/weierli/2.png" alt="" />
            </div>
          </div>
        </div>
        <div class="model">
          <div class="model_title">【项目效果】</div>
          <div class="section">
            项目实现了餐厨垃圾收运与处置所有环节的数据自动上报、报表自动生成，运营过程数字化，帮助餐厨处置企业逐步实现无纸化办公和运营管理。
          </div>
          <div class="section">
            通过对前端收运流程的优化，餐厨垃圾收运效率提升至少30%，收运过程的违规行为减少95%以上，为项目月平均收运量提高了33%以上。
          </div>
          <div class="section">
            通过人工智能与大数据的辅助餐厨处置厂的良性运转，将95%以上业务线上化处理，提高80%以上任务完成效率，有效降低30%以上的运营成本。
          </div>
          <div class="section">
            对设备运行和物耗环节集合大数据进行分析、优化，提出改良建议，同时辅以人工智能手段进行自动控制，为西安餐厨平均降低70%以上的无效能耗、物耗成本，实现厂内运行节能降耗的目的。
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CaseTianjianDetail",
  data() {
    return {
      detailId: this.$route.params.id
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.init();
  },
  methods: {
    init() {
      console.log(this.detailId);
    }
  }
};
</script>

<style lang="scss" scoped>
.carousel {
  background-color: #1a1a1a;
  height: 4rem;
  text-align: center;
  line-height: 4rem;
  font-size: 0.4rem;
  color: #ffffff;
}

.case_main {
  padding: 0 2.4rem;
  margin-bottom: 0.3rem;

  .case_top {
    margin-top: 0.6rem;

    .case_title {
      font-size: 0.32rem;
    }

    .case_time {
      margin-top: 0.2rem;
      font-size: 0.18rem;
      color: #999999;
      display: flex;
      align-items: center;
      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.1rem;
      }
    }

    hr {
      margin-top: 0.4rem;
      color: #cccccc;
    }
  }

  .case_detail {
    margin: 0 2.2rem;
    margin-bottom: 0.6rem;
    color: #000000;
    img {
      width: 100%;
    }
    .model {
      margin-top: 0.2rem;
      .model_title {
        font-size: 0.22rem;
        font-weight: 600;
      }
      .imageContainer {
        width: 100%;
        display: flex;
        justify-content: space-around;
        // padding-left: 2.0em;
        img {
          width: 2.4rem;
        }
      }
      .section {
        padding-left: 0.12rem;
        text-indent: 2em;
        line-height: 0.36rem;
        font-size: 0.18rem;
        margin-top: 0.12rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail_page/CaseWeierliDetail1.vue